import React, { useEffect, useState } from "react";
import FormMember from "./FormMember";
import { Typography } from "@mui/material";
import ModalBox from "../../ui/ModalBox";
import { useNavigate, useParams } from "react-router-dom";
import { useMember } from "./provider";

const UpdateMember = () => {
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    state: { selected: member },
    fetchOne: getMembershipInfo,
  } = useMember();
  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  const handleSuccess = () => {
    setOpen(true);
  };
  useEffect(() => {
    getMembershipInfo(id);
  }, [id]);
  if (!member) return;
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Edit Member
      </Typography>
      <FormMember handleSuccess={handleSuccess} member={member} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The update operation has been completed successfully.. You update"
        name="Membership"
      />
    </>
  );
};

export default UpdateMember;
